import React from 'react'
import SVG from 'react-inlinesvg';
import arrow from '@assets/arrow-up.svg'

const Arrow = () =>
  <SVG src={arrow} className="race-card__arrow" />

export default Arrow
